import React, { useState, useEffect } from "react";
import "./TVTokenDialog.css";
import { Modal, Input, Row, Col, Select } from "antd";
import { useSelector } from "react-redux";
import lang from "../../../../services/lang";
import { GetMachineList } from "../../../../services/common/cnc_apis";

const { Option } = Select;

function TVTokenDialog(props) {
  const { langIndex } = useSelector((x) => x.app);
  const cwService = useSelector((x) => x.cwService);
  const cncService = useSelector((x) => x.cncService);
  const {
    initTokenInfo,
    isShowModal,
    setIsShowModal,
    addToken,
    editToken,
    selCustomerId,
  } = props;
  const [tokenInfo, setTokenInfo] = useState({
    token_name: "",
    dashboard_type: "cnc",
    dashboard_id: "",
    machine_id: "",
    machine_group_id: "",
  });
  const [machineList, setMachineList] = useState([]);
  const [customDashboardList, setCustomDashboardList] = useState([]);
  const [machineGroupList, setMachineGroupList] = useState([]);

  useEffect(() => {
    if (initTokenInfo != null) {
      setTokenInfo({
        ...initTokenInfo,
      });
    } else {
      setTokenInfo({
        token_name: "",
        dashboard_type: "cnc",
        dashboard_id: "",
        machine_id: "",
        machine_group_id: "",
      });
    }
  }, [initTokenInfo]);

  useEffect(() => {
    // Load machines
    GetMachineList(selCustomerId, (mList) => {
      if (mList != null && mList.length > 0) {
        setMachineList(mList);
      } else {
        setMachineList([]);
      }
    });

    // Load custom dashboards
    const customDashboards = cwService.cwDashboards[selCustomerId];
    if (customDashboards != null && customDashboards != undefined) {
      setCustomDashboardList(customDashboards);
    } else {
      setCustomDashboardList([]);
    }

    // Load machine groups
    const customerInfo = cncService.customerInfoList[selCustomerId];
    if (customerInfo && customerInfo.groupInfo) {
      setMachineGroupList(customerInfo.groupInfo);
    } else {
      setMachineGroupList([]);
    }
  }, [selCustomerId, cwService.cwDashboards, cncService.customerInfoList]);

  const onClickOk = () => {
    if (!tokenInfo.token_name || tokenInfo.token_name.trim() === "") {
      return;
    }

    // Validate required fields based on dashboard type
    if (
      tokenInfo.dashboard_type === "custom_dashboard" &&
      (!tokenInfo.dashboard_id || tokenInfo.dashboard_id.trim() === "")
    ) {
      return;
    }

    if (
      (tokenInfo.dashboard_type === "machine_schedule" ||
       tokenInfo.dashboard_type === "machine_detail" ||
       tokenInfo.dashboard_type === "machine_detail_utilization") &&
      (!tokenInfo.machine_id || tokenInfo.machine_id.trim() === "")
    ) {
      return;
    }

    const submitData = {
      ...tokenInfo,
    };

    if (initTokenInfo == null) {
      addToken(submitData);
    } else {
      editToken(submitData);
    }
  };

  const onClickCancel = () => {
    setIsShowModal(false);
  };

  const onSelectDashboardType = (value) => {
    setTokenInfo({
      ...tokenInfo,
      dashboard_type: value,
      dashboard_id: "",
      machine_id: "",
      machine_group_id: "",
    });
  };

  const onSelectDashboardId = (value) => {
    setTokenInfo({ ...tokenInfo, dashboard_id: value });
  };

  const onSelectMachineId = (value) => {
    setTokenInfo({ ...tokenInfo, machine_id: value });
  };

  const onSelectMachineGroupId = (value) => {
    setTokenInfo({ ...tokenInfo, machine_group_id: value });
  };

  const getDashboardTypeOptions = () => {
    return [
      { value: "cnc", label: lang(langIndex, "tv_token_dashboard_cnc") },
      {
        value: "utilization",
        label: lang(langIndex, "tv_token_dashboard_utilization"),
      },
      {
        value: "machine_detail",
        label: lang(langIndex, "tv_token_dashboard_machine_detail") + " (CNC)",
      },
      {
        value: "machine_detail_utilization",
        label: lang(langIndex, "tv_token_dashboard_machine_detail") + " (Utilization)",
      },
      {
        value: "machine_schedule",
        label: lang(langIndex, "tv_token_dashboard_machine_schedule"),
      },
      { value: "tms", label: lang(langIndex, "tv_token_dashboard_tms") },
      {
        value: "tms_alarm",
        label: lang(langIndex, "tv_token_dashboard_tms_alarm"),
      },
      {
        value: "sensor",
        label: lang(langIndex, "tv_token_dashboard_sensor"),
      },
      {
        value: "maintenance",
        label: lang(langIndex, "tv_token_dashboard_maintenance"),
      },
      { value: "report", label: lang(langIndex, "tv_token_dashboard_report") },
      {
        value: "job_entry",
        label: lang(langIndex, "tv_token_dashboard_job_entry"),
      },
      {
        value: "custom_dashboard",
        label: lang(langIndex, "tv_token_dashboard_custom"),
      },
    ];
  };

  const requiresDashboardId = () => {
    return tokenInfo.dashboard_type === "custom_dashboard";
  };

  const requiresMachineId = () => {
    return tokenInfo.dashboard_type === "machine_schedule" || 
           tokenInfo.dashboard_type === "machine_detail" ||
           tokenInfo.dashboard_type === "machine_detail_utilization";
  };

  const requiresMachineGroupId = () => {
    return tokenInfo.dashboard_type === "cnc" || 
           tokenInfo.dashboard_type === "utilization";
  };

  return (
    <div>
      <Modal
        title={
          initTokenInfo == null
            ? lang(langIndex, "tv_token_add_new")
            : lang(langIndex, "tv_token_edit")
        }
        visible={isShowModal}
        onOk={onClickOk}
        onCancel={onClickCancel}
        destroyOnClose={true}
        className="user-setting-modal-style"
        width={600}
      >
        <div>
          <Row style={{ marginTop: 10 }}>
            <Col span={8}>
              <span>{lang(langIndex, "tv_token_name")}</span>
            </Col>
            <Col span={16}>
              <Input
                style={{ background: "#1e1e1e", color: "#eeeeee" }}
                value={tokenInfo.token_name || ""}
                onChange={(e) =>
                  setTokenInfo({ ...tokenInfo, token_name: e.target.value })
                }
                placeholder="e.g., Production Floor TV 1"
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col span={8}>
              <span>{lang(langIndex, "tv_token_dashboard_type")}</span>
            </Col>
            <Col span={16}>
              <Select
                value={tokenInfo.dashboard_type}
                className="page-changer-style"
                dropdownClassName="page-changer-style-dropdown"
                onChange={onSelectDashboardType}
                style={{ width: "100%" }}
              >
                {getDashboardTypeOptions().map((option) => (
                  <Option
                    key={option.value}
                    className="page-changer-item"
                    value={option.value}
                  >
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          {requiresDashboardId() && (
            <Row style={{ marginTop: 10 }}>
              <Col span={8}>
                <span>{lang(langIndex, "tv_token_dashboard_id")}</span>
              </Col>
              <Col span={16}>
                <Select
                  value={tokenInfo.dashboard_id || undefined}
                  className="page-changer-style"
                  dropdownClassName="page-changer-style-dropdown"
                  onChange={onSelectDashboardId}
                  style={{ width: "100%" }}
                  placeholder="Select Dashboard"
                >
                  {customDashboardList.map((dashboard) => (
                    <Option
                      key={dashboard.id}
                      className="page-changer-item"
                      value={dashboard.id.toString()}
                    >
                      {dashboard.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}
          {requiresMachineGroupId() && (
            <Row style={{ marginTop: 10 }}>
              <Col span={8}>
                <span>{lang(langIndex, "tv_token_machine_group")}</span>
              </Col>
              <Col span={16}>
                <Select
                  value={tokenInfo.machine_group_id || undefined}
                  className="page-changer-style"
                  dropdownClassName="page-changer-style-dropdown"
                  onChange={onSelectMachineGroupId}
                  style={{ width: "100%" }}
                  placeholder={lang(langIndex, "tv_token_machine_group_all")}
                  allowClear
                >
                  <Option
                    key="all"
                    className="page-changer-item"
                    value=""
                  >
                    {lang(langIndex, "tv_token_machine_group_all")}
                  </Option>
                  {machineGroupList.map((group) => (
                    <Option
                      key={group.id}
                      className="page-changer-item"
                      value={group.id.toString()}
                    >
                      {group.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}
          {requiresMachineId() && (
            <Row style={{ marginTop: 10 }}>
              <Col span={8}>
                <span>{lang(langIndex, "tv_token_machine_id")}</span>
              </Col>
              <Col span={16}>
                <Select
                  value={tokenInfo.machine_id || undefined}
                  className="page-changer-style"
                  dropdownClassName="page-changer-style-dropdown"
                  onChange={onSelectMachineId}
                  style={{ width: "100%" }}
                  placeholder="Select Machine"
                >
                  {machineList.map((machine) => (
                    <Option
                      key={machine.machine_id}
                      className="page-changer-item"
                      value={machine.machine_id}
                    >
                      {machine.machine_id}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default TVTokenDialog;

